<template>
  <div class="container-fluid mt-2" id="changePasswordPage">
    <div class="row">
      <div class="card">
        <div class="card-header font-weight-bold">
          Genel Ayarlar
        </div> <!-- tr -->
        <div class="card-block">
          <div class="row">
            <div class="form-group col-sm-6">
              <label>{{ t.app || 'App' }}</label> <!-- tr -->
              <input type="text" name="title" :value="$root.app.name" class="form-control" disabled="">
            </div>
            <div class="form-group col-sm-6">
              <label>App URL</label> <!-- tr -->
              <input type="text" name="url" :value="appURL" class="form-control" disabled="">
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button type="submit" class="btn btn-link btn-sm">{{ t.update }}</button> <!-- tr -->
        </div>
      </div>
      <form>
        <div class="card">
          <div class="card-header font-weight-bold">
            {{ t.navigation.change_password }}
          </div>
          <div class="card-block">
            <div class="row">
              <div class="form-group col-sm-3">
                <label>{{ t.user.username }}</label>
                <input type="text" name="username" class="form-control" required="" :value="session.username" disabled="">
              </div>
              <symForm :options="opt" :data.sync="formData" v-on:sended="setForm" :form.sync="userForm" :formProcess.sync="formProcess" v-if="userForm" />
            </div>
          </div>
          <div class="card-footer">
            <button type="submit" name="button" value="OK" class="btn btn-link btn-sm" style="opacity: 0; pointer-events: none">{{ t.navigation.change_password }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import symForm from '@/components/form/symForm';
export default {
  name: "ChangePassword",
  components: {symForm},
  data() {
    return {
      session: session,
      opt: {
        username: {data: [], label: 'username'},
      },
      formData: [],
      userForm: null,
      formProcess: 0,
      t: this.$root.t,
      appURL: window.location.origin
    }
  },
  mounted() {
    this.getUserForm();
  },
  methods: {
    async getUserForm(data) {
      this.userForm = null;
      this.formProcess = 0;
      this.$bus.$emit('globalLoader', 1);
      if (data) {
      } else {
        this.$http.get(api + 'api/change-password')
            .then(response => {
              this.userForm = response.body.result;
              this.formData = {username: ''};
              this.$bus.$emit('globalLoader', 0);
            }, response => {
              this.$bus.$emit('globalLoader', 0);
            })
      }

    },

    async setForm(data) {
      this.userForm = null;
      this.$http.post(api + 'api/change-password',
          data)
          .then(response => {
            this.userForm = response.body.result;
            this.formProcess = 200;
            this.$fire({
              title: "",
              text: this.t.processing.success,
              type: "success",
              timer: 3000
            }).then(r => {
              console.log(r.value);
            });
          }, response => {
            this.userForm = response.body.result;
            this.formProcess = 400;
            this.$fire({
              title: this.t.processing.error,
              text: this.t.processing.check,
              type: "error",
              timer: 3000
            }).then(r => {
              console.log(r.value);
            });
          })

    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/ChangePassword.vue